import { render, staticRenderFns } from "./loggedinHome.vue?vue&type=template&id=470baa62&"
import script from "./loggedinHome.vue?vue&type=script&lang=js&"
export * from "./loggedinHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports